import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { servers } from "../index"
import { Button, Container, HStack, Radio, RadioGroup,  } from '@chakra-ui/react'
import Loader from './Loader'
import ErrorComponent from './ErrorComponent'
import CoinCard from './CoinCard'


const Coins = () => {

  const [coins, setCoins] = useState([])

  const [loading, setLoading] = useState(true)

  const [error, setError] = useState(false)

  const [page, setPage] = useState(1)
  const [currency, setCurrency] = useState("inr")

  const currencySymbol = currency ==="inr"? "₹" : currency === "eur"? "€" : "$"


  const changePage =(page)=>{
    setPage(page);
    setLoading(true)
  }

  const btns = new Array(132).fill(1)

  useEffect(() => {

    const fetchCoins = async () => {
      try {
        const { data } = await axios.get(`${servers}/coins/markets?vs_currency=${currency}&page=${page}`);

        setCoins(data);
        setLoading(false)
      }
      catch (e) {
        setError(true)
        setLoading(false)
        console.log(e);

      }
    }
    fetchCoins();

  }, [currency,page]);

  if(error)
    return <ErrorComponent message={"Error while Fetching Coins"}/>

  return (
    <Container maxW={"container.xl"}>

      {loading ? (<Loader />) : (
      
      <>

      <RadioGroup value={currency} onChange={setCurrency} p={"8"}>
        <HStack spacing={"4"}>
          <Radio value="inr">INR</Radio>
          <Radio  value="usd">USD</Radio>
          <Radio  value="eur">EUR</Radio>
        </HStack>
      </RadioGroup>

          <HStack wrap={"wrap"} justifyContent={"space-evenly"}>

            {
              coins.map((i) => (

                <CoinCard
                  id={i.id}
                  key={i.id}
                  name={i.name}
                  price={i.current_price}
                  img={i.image} 
                  symbol={i.symbol}
                  currencySymbol={currencySymbol}/>
              ))}
          </HStack>

          <HStack p={"8"} overflowX={"auto"}>
              
              {
                btns.map((item, index)=>(
                  <Button 
                  key={index} color={"white"} onClick={()=>changePage(index+1)}
                  bgColor={'blackAlpha.900'}
                  
                  >{index+1}</Button>
                  
                ))
              }
          </HStack>
        </>)}
    </Container>
  )
}




export default Coins